import { Button, Modal, Stack, Text } from '@mantine/core';
import React from 'react';

import { SubscriptionDetailsType } from '@portals/api/partners';
import { ModalBody, ModalFooter } from '@portals/core';
import { ProductPricingModel } from '@portals/types';
import { mediumDateFormatter } from '@portals/utils';

interface SubscriptionCancellationConfirmModalProps {
  isOpen: boolean;
  subscription: SubscriptionDetailsType;
  onCancel: () => void;
  onConfirm: () => void;
}

export function SubscriptionCancellationConfirmModal({
  isOpen,
  subscription,
  onCancel,
  onConfirm,
}: SubscriptionCancellationConfirmModalProps) {
  let descriptionMessage;

  if (subscription.product.pricing_model === ProductPricingModel.UsageBased) {
    descriptionMessage = (
      <Text>
        You are about to cancel the subscription for this product. By
        cancelling, the customer will lose access to its features and benefits
        immediately.
      </Text>
    );
  } else {
    descriptionMessage = (
      <Text>
        You are about to cancel the subscription for this product. By
        cancelling, the customer will lose access to its features and benefits
        when the current billing period expires on{' '}
        <strong>{mediumDateFormatter(subscription.next_charge_at)}</strong>.
      </Text>
    );
  }

  return (
    <Modal
      opened={isOpen}
      onClose={onCancel}
      title="Confirm Subscription Cancellation"
      padding="xxl"
    >
      <ModalBody>
        <Stack>{descriptionMessage}</Stack>
      </ModalBody>

      <ModalFooter position="right">
        <Button variant="default" onClick={onCancel}>
          Keep Subscription
        </Button>
        <Button
          color="red"
          onClick={onConfirm}
          data-testid="cancel-subscription-button"
        >
          Cancel Subscription
        </Button>
      </ModalFooter>
    </Modal>
  );
}
